(() => {
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency', currency: window.Shopify?.currency?.active || 'USD'
  }).format(cents / 100);

  const toast = document.querySelector('[data-toast]');
  let toastTimer;
  const showToast = (message) => {
    if (!toast) return;
    toast.textContent = message;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { toast.hidden = true; }, 2800);
  };

  const drawer = document.querySelector('[data-cart-drawer]');
  const drawerContent = document.querySelector('[data-cart-content]');
  const drawerFooter = document.querySelector('[data-cart-footer]');

  const renderCart = (cart) => {
    document.querySelectorAll('[data-cart-count]').forEach((node) => {
      node.textContent = cart.item_count;
      node.hidden = cart.item_count === 0;
    });
    if (!drawerContent || !drawerFooter) return;
    if (!cart.items.length) {
      drawerContent.innerHTML = '<p class="muted">Your cart is empty.</p>';
      drawerFooter.hidden = true;
      return;
    }
    drawerContent.innerHTML = cart.items.map((item) => `
      <article class="drawer-item">
        ${item.image ? `<img src="${item.image}" alt="">` : '<div></div>'}
        <div><h3><a href="${item.url}">${item.product_title}</a></h3><p>${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title + ' · ' : ''}Qty ${item.quantity}</p></div>
        <strong>${money(item.final_line_price)}</strong>
      </article>
    `).join('');
    drawerFooter.querySelector('[data-cart-total]').textContent = money(cart.total_price);
    drawerFooter.hidden = false;
  };

  const getCart = async () => {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
    if (!response.ok) throw new Error('Could not load cart');
    return response.json();
  };

  const openDrawer = async () => {
    if (!drawer) return;
    drawer.hidden = false;
    document.body.classList.add('drawer-open');
    try { renderCart(await getCart()); } catch (_) {}
  };
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.hidden = true;
    document.body.classList.remove('drawer-open');
  };

  document.addEventListener('click', (event) => {
    const quantityButton = event.target.closest('[data-quantity-change]');
    if (quantityButton) {
      const wrap = quantityButton.closest('[data-quantity]');
      const input = wrap?.querySelector('input');
      if (!input) return;
      input.value = Math.max(1, Number(input.value || 1) + Number(quantityButton.dataset.quantityChange));
      return;
    }

    if (event.target.closest('[data-cart-open]')) { event.preventDefault(); openDrawer(); }
    if (event.target.closest('[data-cart-close]')) closeDrawer();

    const menuButton = event.target.closest('[data-menu-toggle]');
    if (menuButton) {
      const menu = document.querySelector('[data-mobile-menu]');
      const open = menu.hidden;
      menu.hidden = !open;
      menuButton.setAttribute('aria-expanded', String(open));
    }

    const searchButton = event.target.closest('[data-search-toggle]');
    if (searchButton) {
      const panel = document.querySelector('[data-search-panel]');
      const open = panel.hidden;
      panel.hidden = !open;
      searchButton.setAttribute('aria-expanded', String(open));
      if (open) panel.querySelector('input')?.focus();
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-ajax-cart-form]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    const original = button?.textContent;
    if (button) { button.disabled = true; button.textContent = 'Adding…'; }
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form)
      });
      if (!response.ok) throw new Error((await response.json()).description || 'Could not add item');
      renderCart(await getCart());
      openDrawer();
      showToast('Added to your garage cart.');
    } catch (error) {
      showToast(error.message || 'Something went wrong.');
    } finally {
      if (button) { button.disabled = false; button.textContent = original; }
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeDrawer();
      const menu = document.querySelector('[data-mobile-menu]');
      if (menu) menu.hidden = true;
      const search = document.querySelector('[data-search-panel]');
      if (search) search.hidden = true;
    }
  });
})();
